<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 7/3/2021
  -->

<!-- eslint-disable vue/no-mutating-props -->

<template>
	<div class="qwoach-form coaching-sessions-root relative">
		<PanelTitle v-if="!hideTitle">
			Coaching Sessions
		</PanelTitle>

		<div v-if="sessionTypeList">
			<div class="row mx-0 align-items-center">
<!--				<template #after>-->
					<ToolTipView
						v-if="!sessionType || sessionType.needsSetup"
						:analyticsProps="{label: 'Set session type', props: analyticsPropsMethod()}"
						placement="top">
						<template #icon><i  class="fontello icon-warning-empty text-danger mr-1"/></template>
						Please select at least one session type to use in this program.
					</ToolTipView>
<!--				</template>-->

				<FormSelectRow
					class="col px-0"
					:options="sessionTypeList"
					v-model="valueData"
					placeholder="Select session type"
					label-key="displayName"
					value-key="id"
					:tooltip-text="sessionTypeTooltipText"
					:showLoading="sessionTypeListNeedsLoading"
					:tooltipAnalyticsProps="{label: 'Select session type', ...analyticsPropsMethod()}"
					v-bind="formElemSettings"
					:label-transform="labelTransform"
					@visible-change="onDropdownVisibilityChanged"
					@change="onSessionTypeSelected">
					<template #default="{option: eventType}">
						<div v-if="eventType.id === 'createNew'">
							<hr v-if="sessionTypeList.length > 1" style="margin: 0"/>
							<div class="bold">{{ eventType.displayName}}</div>
						</div>
						<div v-else class="row mx-0">
							<div class="col px-0">
								<span>
									{{ eventType.displayName || "needs setup"}}
								</span>
							</div>
							<div class="layout-spacer"></div>
							<ToolTipView
										 v-if="eventType.needsSetup"
										 :analyticsProps="{label: 'Session type needs setup', props: analyticsPropsMethod()}"
										 placement="top">
								<template #icon><i  class="fontello icon-warning-empty text-danger mr-1"/></template>
								<div>
									This session type needs setup.
									<br/><br/>
									Please open this session, fill in all the required fields and press "save".
								</div>
							</ToolTipView>

							<!--							<div>-->
<!--								<i class="button-circle fontello icon-pencil"-->
<!--									@click.stop="onSessionTypeEditClicked(eventType)"/>-->
<!--							</div>-->
						</div>
					</template>

					<template #empty>
						<div
							style="height: 150px; position: relative">
							<LoadingIndicator
								:is-loading="sessionTypeListNeedsLoading"
								message="Loading..."
								class="center-absolute"/>
						</div>
					</template>


					<template #after>
						<ToolTipView
							v-if="sessionType"
							:disabled="!!sessionType"
							:analyticsProps="{label: 'Edit session type', props: analyticsPropsMethod()}"
							placement="top">
							<template #icon><i  class="button-circle fontello icon-pencil"
							   :class="{'disabled': !sessionType}"
							   @click="onSessionTypeEditClicked(sessionType)"/></template>
							To edit a session type, please first select it from the dropdown on the left
						</ToolTipView>
					</template>



				</FormSelectRow>
			</div>

			<div v-if="valueData">
				<div class="mb-3" style="margin-top: -5px;">
					<div class="mb-1">
						<small class="text-muted">
							<div>Duration: {{valueData.durationMinutes()}} minutes</div>
						</small>
					</div>
					<div>
						<small class="text-muted">
							<div>Email reminder: {{valueData.isEmailReminderEnabled ? 'enabled' : 'disabled'}}</div>
						</small>
					</div>
				</div>
			</div>
<!--				<FormRow-->
<!--					:isTitleBold="false"-->
<!--					tooltip-text="You can add preparation coaching form and it will be sent to your clients automatically before each session."-->
<!--					tooltipBubblePosition="top"-->
<!--					title="Prep coaching form:"-->
<!--					@edit="onEditPrepForm">-->
<!--					<div><span v-html="sessionType.isPrepFormEnabled ? textEnabled : textDisabled"/></div>-->
<!--				</FormRow>-->
<!--				<FormRow-->
<!--					:isTitleBold="false"-->
<!--					tooltip-text="You can add post coaching form and it will be sent to your clients automatically after each session."-->
<!--					tooltipBubblePosition="top"-->
<!--					title="Post coaching form:"-->
<!--					@edit="onEditPostForm">-->
<!--					<div><span v-html="sessionType.isPostFormEnabled ? textEnabled : textDisabled"/></div>-->
<!--				</FormRow>-->

				<FormRow
					v-if="hasActiveRecurringSession"
					v-bind="formElemSettings"
					:tooltipAnalyticsProps="{label: 'Sessions limit: recurring sessions', ...analyticsPropsMethod()}"
					tooltip-text="There is an ongoing series of recurring sessions.<br/><br/>To control the number of sessions, please open one of the recurring sessions on the left and use the recurrence rules there."
					@change="onTotalNumberOfSessionsChange"
					title="Sessions limit">
					N/A
				</FormRow>
				<FormNumberRow
					v-else
					v-bind="formElemSettings"
					:tooltip-text="sessionNumberTooltipText"
					:input-debounce-delay="2000"
					:tooltipAnalyticsProps="{label: 'Sessions limit', ...analyticsPropsMethod()}"
					@change="onTotalNumberOfSessionsChange"
					v-model="programItem.sessionsLimit"
					title="Sessions limit">
					<template #postfix v-if="!programItem.sessionsLimit">
						<ToolTipView
									 :analyticsProps="{label: 'Session limit not set', props: analyticsPropsMethod()}"
									 placement="top">
							<template #icon><i  class="fontello icon-warning-empty text-warning"/></template>
							Your clients won't be able to schedule sessions with you since the limit is set to zero.
							<br/><br/>
							If you want to allow your clients to schedule sessions, please put a number here.
							<br/><br/>
							Otherwise it's safe to ignore this warning.
							<br/><br/>
							Your client's won't see any warnings in their dashboard.
						</ToolTipView>
					</template>
				</FormNumberRow>

				<FormRow
					v-if="showCompletedSessions"
					v-bind="formElemSettings"
					:tooltip-text="sessionNumberCompletedTooltipText"
					:input-debounce-delay="2000"
					:readonly="true"
					:tooltipAnalyticsProps="{label: 'Completed sessions', ...analyticsPropsMethod()}"
					title="Completed sessions">
					<div class="text-muted">{{completedSessionCount}}
<!--						<span v-if="!programItem.hasActiveRecurringSession()"> of {{sessionCount}}</span>-->
					</div>
				</FormRow>

<!--				<FormRow-->
<!--					v-bind="formElemSettings"-->
<!--					tooltip-text="Your clients would typically schedule sessions on their own. <br/><br/>However you can also schedule a session on your end"-->
<!--					:input-debounce-delay="2000"-->
<!--					:readonly="true"-->
<!--					@change="onTotalNumberOfSessionsChange"-->
<!--					v-model="programItem.numberOfSessionsTotal">-->
<!--					<a href="#" @click.prevent @click="onScheduleSessionManually">+ Schedule a session</a>-->
<!--				</FormRow>-->



		</div>

<!--		<qw-drawer-->
<!--			v-model="showEditSessionType"-->
<!--			:parentRouteName="backRouteName"-->
<!--			:closeRouteName="drawerCloseRouteName"-->
<!--			:modal="modal"-->
<!--			:size="drawerSize"-->
<!--			:wrapperClosable="false"-->
<!--			class="coaching-session-drawer-root"-->
<!--			@close="onDrawerClosed"-->
<!--			@change="onDrawerOpenStateChanged">-->
<!--&lt;!&ndash;				<EventTypeSettingsView&ndash;&gt;-->
<!--&lt;!&ndash;					v-bind="$attrs"&ndash;&gt;-->
<!--&lt;!&ndash;					:hideMenu="true"&ndash;&gt;-->
<!--&lt;!&ndash;					class="py-3"/>&ndash;&gt;-->

<!--			<router-view-->
<!--					v-bind="$attrs"-->
<!--					:hideMenu="true"-->
<!--					class="py-3"/>-->
<!--		</qw-drawer>-->

		<dialogs-wrapper name="session-panel-type-drawer"/>

		<LoadingIndicator class="center-absolute"/>
	</div>
</template>

<script>

import FormNumberRow from "@/core/components/Form/FormNumberRow.vue";
import FormSelectRow from "@/core/components/Form/FormSelectRow.vue";
import LoadingIndicator from "@/core/components/LoadingIndicator.vue";
import CoachingProgram from "@shared/Program/CoachingProgram";
import EventType from "@shared/scheduler/EventType";
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import BaseVModelView from "@/core/components/BaseVModelView.vue";
import PanelTitle from "@/core/modules/coach/Coaching/Panels/PanelTitle.vue";
import ToolTipView from "@/core/components/Form/Base/ToolTipView.vue";
import {createDrawer} from "@/utils/helpers-external.js";
import SessionTypeDrawer from "@/core/modules/coach/Coaching/Panels/CoachingSessionsPanel/SessionTypeDrawer.vue";
import {classToClass} from "@qwoach/class-transformer-wrapper";

/* eslint-disable vue/no-mutating-props */

let sessionTypeDrawer = createDrawer(SessionTypeDrawer, {wrapper: "session-panel-type-drawer"})

export default {
	name: "CoachingSessionsPanel",
	components: {ToolTipView, PanelTitle, FormRow, LoadingIndicator, FormSelectRow, FormNumberRow},
	extends: BaseVModelView,
	props: {
		programItem: CoachingProgram,
		modal: {Boolean, default: true},
		mainRouteName: {String, required: true},
		backRouteName: {String, required: true},
		showCompletedSessions:{Boolean, default: true},
		tooltipAnalyticsProps: Object,
		analyticsProps: {Object, default: () => ({})},
		hideTitle: Boolean,
		drawerSize: String,
		showToast: {Boolean, default: true}
	},

	data() {
		return {
			sessionTypeListNeedsLoading: true,
			sessionTypeList: [],
			showEditSessionType: false,
			sessionTypeTooltipText: "Session type provides details like length of the session, it's location, cancellation policy<!--, pre-/post session forms--> and more.<br/><br/>It will be used to let your clients schedule sessions with you.",
			sessionNumberTooltipText: "Specify the total number of available sessions for this program.<br/><br/> This is the maximum number of sessions your clients can schedule as part of this program.<br/><br/>You can always change this number as needed during the coaching.",
			sessionNumberCompletedTooltipText: "Shows the number of completed sessions.",

			drawerCloseRouteName: null,
			backRouteNameForm: null,
			prepFormRouteName: null,
			postFormRouteName: null,
		}
	},

	created(){
		this.setupRoutes()
	},

	mounted() {
		// this.onDropdownVisibilityChanged(true)
	},

	methods: {

		onValueChanged(){
			this.sessionTypeListNeedsLoading = true
		},

		formatDataIn(data) {
			return data
		},

		formatDataOut(data) {
			return data
		},



		setupRoutes(){
			this.backRouteNameForm = this.mainRouteName + "Settings"
			this.prepFormRouteName = this.mainRouteName + "PrepForm"
			this.postFormRouteName = this.mainRouteName + "PostForm"
		},

		async loadDataSessionTypeList() {
			this.sessionTypeList = await this.handleAsyncNonBlocking(() => this.$dataManager.listSessionTypes())
			let createNew = new EventType()
			createNew.id = "createNew"
			createNew.displayName = "Create new session type"
			this.sessionTypeList.push(createNew)
			console.log("loadDataSessionTypeList = ", this.sessionTypeList)
		},

		async onEditPrepForm(){
			this.drawerCloseRouteName = this.backRouteNameForm
			await this.openDrawer(this.sessionType, this.prepFormRouteName)
		},
		async onEditPostForm(){
			this.drawerCloseRouteName = this.backRouteNameForm
			await this.openDrawer(this.sessionType, this.postFormRouteName)
		},

		async onSessionTypeEditClicked(sessionType){
			let _ = this.$analyticManager.trackEvent("Session type edit clicked", {sessions_limit: this.programItem.sessionsLimit, ...this.analyticsPropsMethod(), session_type_id: sessionType.id})
			this.drawerCloseRouteName = this.backRouteName
			return await this.openDrawer(sessionType, this.mainRouteName)
			// this.drawerCloseRouteName = "TemplateDetailsCoach"
			// await this.openDrawer(sessionType, "ProgramTemplateEventType")
		},

		async openDrawer(sessionType, routeName){
			// passing the copy further to ensure the original value is not mutated (important if settings screen is canceled after edits are done)
			sessionType = classToClass(sessionType)
			console.log("openDrawer: this.drawerCloseRouteName = ", this.drawerCloseRouteName, ", this.backRouteName = ", this.backRouteName)
			this.showEditSessionType = true
			await this.go(routeName, {
				...this.$attrs,
				mainRouteName: this.mainRouteName,
				backRouteName: this.backRouteName,
				eventTypeId: sessionType.id,
				eventTypeProp: sessionType,
			}, this.$route.query)

			let selectedSessionType = await sessionTypeDrawer({
				mainRouteName: this.mainRouteName,
				backRouteName: this.backRouteName,
				drawerCloseRouteName: this.drawerCloseRouteName,
				eventTypeId: sessionType.id,
				eventTypeProp: sessionType,
				modal:this.modal,
				hideToast: true,
				attrs: this.$attrs
			})

			console.log("CoachingSessionsPanel: selectedSessionType = ", selectedSessionType)

			let canSelect = selectedSessionType && !selectedSessionType.needsSetup

			console.log("CoachingSessionsPanel: canSelect = ", canSelect)

			if(canSelect){
				this.valueData = selectedSessionType
				console.log("CoachingSessionsPanel: this.valueData = ", this.valueData)
				await this.onSessionTypeSelected(selectedSessionType)
			}
			console.log("openDrawer opened")
			return selectedSessionType
		},

		async onDrawerClosed(){
			console.log("CoachingSession: onDrawerClosed")
			this.valueData = await this.handleAsyncNonBlocking(this.$dataManager.apiGetEventType({sessionTypeId: this.valueData.id, coachId: this.getCoachId()}))
			this.notifyValueChanged()
		},

		async onDrawerOpenStateChanged(){
			// if(!this.showEditSessionType){
			//
			// }
		},

		async onDropdownVisibilityChanged(visible){
			console.log("onDropdownVisibilityChanged: visible = ", visible)
			if(visible && this.sessionTypeListNeedsLoading){
				await this.loadDataSessionTypeList()
				this.sessionTypeListNeedsLoading = false
			}
		},

		labelTransform(label, eventType){
			if(!label || eventType.needsSetup){
				label = "--Needs setup--"
			}
			return label
		},

		async onSessionTypeSelected(sessionType){
			console.log("onSessionTypeSelected: ", sessionType)
			if(sessionType.needsSetup){
				let selectedSessionType = await this.onSessionTypeEditClicked(sessionType)
				console.log("onSessionTypeSelected: new selectedSessionType = ", selectedSessionType)
				if(!selectedSessionType) {
					await this.clearSessionTypeSelection()
				}
			} else if(sessionType.id === "createNew"){
				let eventType = new EventType()
				eventType.needsSetup = true
				eventType.coachId = this.ownerProfile.id
				eventType = await this.handleAsync(() => this.$dataManager.createEventType(eventType))
				if(eventType){
					this.sessionTypeList.unshift(eventType)
					let selectedSessionType = await this.onSessionTypeEditClicked(eventType)
					console.log("onSessionTypeSelected: new selectedSessionType = ", selectedSessionType)
					if(!selectedSessionType) {
						await this.clearSessionTypeSelection()
					}
				}
			} else {
				let _ = this.$analyticManager.trackEvent("Session type changed", {session_type_id: sessionType.id, ...this.analyticsPropsMethod()})
				this.programItem.sessionTypeId = sessionType.id
				this.notifyValueChanged()
				await this.updateProgram()
			}
			console.log("onSessionTypeSelected: sessionType = ", sessionType)
		},

		analyticsPropsMethod(){
			return {
				category: "Coaching sessions panel",
				...this.analyticsProps
			}
		},

		async onTotalNumberOfSessionsChange(){
			let _ = this.$analyticManager.trackEvent("Sessions limit changed", {sessions_limit: this.programItem.sessionsLimit, ...this.analyticsPropsMethod()})
			console.log("onTotalNumberOfSessionsChange")
			await this.updateProgram()
		},

		async clearSessionTypeSelection(){
			await this.$nextTickPromise()
			this.valueData = null
		},

		async updateProgram(){
			let res = await this.handleAsync(() => this.$dataManager.updateProgram(this.programItem), "Saving...")
			if(res && this.showToast){
				this.toast("Program updated successfully")
			}
		},

		async onScheduleSessionManually(){
			console.log("onScheduleSessionManually")
			// let res = await NewSessionCoachDialog()

		}
	},

	computed:{
		sessionType(){
			return this.valueData
		},

		textEnabled(){
			return "enabled"//'<span class="text-success">enabled</span>'
		},
		textDisabled(){
			return '<span class="text-warning">disabled</span>'
		},

		formElemSettings(){
			return {
				isTitleBold: false,
				tooltipBubblePosition: "top"
			}
		},

		completedSessionCount(){
			return this.programItem.completedSessionCount() || 0
		},

		sessionCount(){
			return this.programItem.sessionCount() || 0
		},

		hasActiveRecurringSession(){
			return this.programItem.hasActiveRecurringSession()
		},


	}
}
</script>

<style lang="scss">
@import "../../../../../../assets/scss/style/variables";
.coaching-sessions-root {
	.form-padding {
		padding: 0;
	}
	.el-drawer{
		background-color: $body-bg;
		padding: 0 15px!important;
	}

	//input::placeholder {
	//	color: rgba($color-danger, 0.7) !important;
	//}


}

</style>
